export default "data:image/webp;base64,UklGRjYAAABXRUJQVlA4TCkAAAAvJ4AGAAVZNhLC+VMc4m9H8INAINlt+6jEginuimD9nwDo/ir70O8AAAA="